interface SectionTitleProps {
  text: string;
}

const SectionTitle = ({ text }: SectionTitleProps) => {
  return <h3 className="fs-20 text-primary fw-700 text-uppercase">{text}</h3>;
};

export default SectionTitle;
